import * as moment from 'moment';

const PERIODS = [
  {
    id: 1,
    name: 'Personalizado',
    disabled: true,
  },
  {
    id: 2,
    name: 'Hoje',
    start: moment().toDate(),
    end: moment().toDate(),
  },
  {
    id: 3,
    name: 'Essa semana',
    start: moment().startOf('week').toDate(),
    end: moment().endOf('week').toDate(),
  },
  {
    id: 4,
    name: 'Esse mês',
    start: moment().startOf('month').toDate(),
    end: moment().endOf('month').toDate(),
  },
  {
    id: 5,
    name: 'Últimos 6 meses',
    start: moment().subtract(6, 'months').toDate(),
    end: moment().endOf('month').toDate(),
  },
  {
    id: 6,
    name: 'Esse ano',
    start: moment().startOf('year').toDate(),
    end: moment().endOf('year').toDate(),
  },
  {
    id: 7,
    name: 'Ano passado',
    start: moment().subtract(1, 'years').startOf('year').toDate(),
    end: moment().subtract(1, 'years').endOf('year').toDate(),
  },
];

export default PERIODS;
